import { Button, Form, Input, message, Select, Space, Table, Checkbox, InputNumber, Popconfirm } from "antd";
import { useEffect, useState } from "react";
import { serverFetch } from "../../server";
import { CloseCircleOutlined } from "@ant-design/icons";
import { isMobile } from "../../extensions/design";
import { ftmPrice } from "../../extensions/utils";

const PaymentAdd = ({ clientId, visitId, onClose }) => {
  const [items, setItems] = useState([]);
  const [vidPaymentsOptions, setvidPaymentsOptions] = useState([]);
  const [vidPayments, setVidPayments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [item, setItem] = useState({});
  const [selected, setSelected] = useState([]);
  const [popconfirmOpen, setPopconfirmOpen] = useState(false);
  const [depositAction, setDepositAction] = useState(null);

  const getSyma = (selected, items) => items.filter(i => selected.includes(i.id)).reduce((p, c) => p + c.debet, 0)

  const getData = () => {
    setLoading(true);
    const url = clientId ? `sale/ListByClient/${clientId}?isPaid=false` : `sale/ListByVisit/${visitId}?isPaid=false`;
    serverFetch(url)
      .then(data => {
        const filtered = data.filter(i => !i.deleted);
        setItems(filtered);
        setLoading(false);

        const newSelected = filtered.map(i => i.id);
        setSelected(newSelected);

        const newItem = { syma: getSyma(newSelected, filtered) };
        setItem(newItem);
        form.setFieldsValue(newItem);
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  const getvidPaymentsOptions = () => {
    const accountsPromise = clientId
      ? serverFetch(`payment/accounts/client/${clientId}`)
      : visitId
        ? serverFetch(`payment/accounts/visit/${visitId}`)
        : Promise.resolve([]);
    const vidPromise = serverFetch("paymentvid");

    Promise.all([vidPromise, accountsPromise])
      .then(([vids, accounts]) => {
        const balances = {};
        console.log(vids)
        accounts.forEach(acc => { balances[acc.id] = acc.syma; });

        const options = vids.map(i => {
          const syma = balances[i.id] || 0;
          const label = syma > 0 ? `${i.name} (остаток: ${ftmPrice(syma)})` : i.name;
          return { value: i.id, label: label, syma: syma, fiscal: i.fiscal };
        });

        setvidPaymentsOptions(options);
        setVidPayments(vids);
      })
      .catch(e => message.error(e.userMessage));
  };

  // Функция принимает текущие (или новые) значения формы и возвращает обновленный newItem
  const calculateNewItem = (changedValue, allValues) => {
    const currentItem = item;
    const newItem = { ...currentItem, ...changedValue };
    
    const selectedPaymentVidId = changedValue.paymentVidId ?? allValues.paymentVidId;
    const selectedPaymentVid = vidPayments.find(i => i.id === selectedPaymentVidId);

    const hasGivenMoney = allValues.givenMoney !== null && allValues.givenMoney !== undefined && allValues.givenMoney !== "" && allValues.givenMoney !== 0;

    if (hasGivenMoney && selectedPaymentVid?.fiscal === 1) {
      const changeMoney = (Number(allValues.givenMoney) || 0) - (Number(allValues.syma) || 0);
      newItem.changeMoney = changeMoney;
      form.setFieldsValue({ changeMoney });
    } else {
      newItem.changeMoney = null;
      form.setFieldsValue({ changeMoney: null });
    }

    return newItem;
  };

  const onValuesChange = (changedValue, allValues) => {
    const updatedItem = calculateNewItem(changedValue, allValues);
    setItem(updatedItem);
  };

  const columns = [
    {dataIndex: "id", title: "#"},
    {dataIndex: "productName", title: "Наименование"},
    {dataIndex: "price", title: "Цена", align: "right"},
    {dataIndex: "qty", title: "Кол.", align: "right"},
    {dataIndex: "syma", title: "Сумма", align: "right"},
    {title: "К оплате", render: record => <div>{record.syma - record.paid}</div>, align: "right"},
  ]

  useEffect(() => {
    getData();
    getvidPaymentsOptions();
  }, [clientId, visitId]);

  const paySales = () => {
    const data = { saleIds: selected, syma: item.syma, paymentVidId: item?.paymentVidId, clientId, visitId }
    return serverFetch("sale/AskPay", { method: "POST", bodyData: data });
  }

  const addChangeToDeposit = () => {
    const depositPaymentVid = vidPayments.find(i => i.fiscal === 21);
    const changeMoney = Number(item?.changeMoney) || 0;

    if (!clientId && !visitId) {
      return Promise.reject({ userMessage: "Не указан клиент или визит для пополнения депозита" });
    }

    if (!depositPaymentVid) {
      return Promise.reject({ userMessage: "Не найден вид оплаты депозита" });
    }

    const data = {
      ...(clientId ? { clientId } : { visitId }),
      paymentVidId: item.paymentVidId,
      paymentVid2Id: depositPaymentVid.id,
      transactionVid: 1,
      syma: changeMoney,
      comment: "Сдача на депозит",
    };

    return serverFetch("payment/deposit", { method: "POST", bodyData: data });
  }

  const openDepositAction = () => {
    const depositPaymentVid = vidPayments.find(i => i.fiscal === 21);

    if (depositAction) {
      setDepositAction(null);
    } else {
      setDepositAction({ paymentVid2Id: depositPaymentVid?.id, syma: '', paymentVidId: null, comment: '' });
    }
  };

  const onDepositSubmit = () => {
    if (!depositAction?.syma || !depositAction?.paymentVidId) {
      message.warning("Заполните сумму и кассу");
      return;
    }

    if (!clientId && !visitId) {
      message.warning("Не указан клиент или визит для пополнения депозита");
      return;
    }

    if (!depositAction?.paymentVid2Id) {
      message.warning("Не найден вид оплаты депозита");
      return;
    }

    const data = {
      ...(clientId ? { clientId } : { visitId }),
      paymentVidId: depositAction.paymentVidId,
      paymentVid2Id: depositAction.paymentVid2Id,
      transactionVid: 1,
      syma: depositAction.syma,
      comment: depositAction.comment,
    };

    setLoading(true);
    serverFetch("payment/deposit", { method: "POST", bodyData: data })
      .then(() => {
        setDepositAction(null);
        setLoading(false);
        getvidPaymentsOptions();
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  };

  // Функция проверки того, что оплачивается - если оплачивается сертификат, нужно убедиться, что для него указаны данные
  async function checkForCertificates() {
    const promises = selected.map(id => serverFetch(`sale/${id}`));
    const results = await Promise.allSettled(promises);

    const isEmpty = (val) => val === null || val === undefined || (typeof val === 'string' && val.trim() === '');

    let status = 'ok'
    
    for (const result of results) {
      if (result.status !== 'fulfilled' || !result.value)
        continue;

      const { productVid, email, name, sign, message } = result.value;

      if (productVid === 4) {
        if (isEmpty(email))
          return 'error';
        if (isEmpty(name) || isEmpty(message) || isEmpty(sign))
          status = 'confirm';
      }
    }
    return status;
  }

  const executePayment = () => {
    setPopconfirmOpen(false);
    const shouldAddChangeToDeposit = item?.changeOnDeposit && (Number(item?.changeMoney) || 0) > 0;
    setLoading(true);

    const savePromise = shouldAddChangeToDeposit
      ? addChangeToDeposit().then(paySales)
      : paySales();

    savePromise
      .then(() => onClose(true))
      .catch(e => {
        setLoading(false);
        message.error(e?.userMessage || "Ошибка оплаты");
      });
  };

  const onSave = async () => {
    setLoading(true);
    const checkStatus = await checkForCertificates();
    setLoading(false);

    if (checkStatus === 'error') {
      message.error("Оплата сертификата невозможна! Заполните email.");
      return;
    }
    
    if (checkStatus === 'confirm') {
      setPopconfirmOpen(true);
      return;
    }
    executePayment();
  }

  const onRowClick = (record) => {
    const key = record.id;
    const newSelected = selected.includes(key) ? selected.filter(k => k !== key) : [...selected, key];
    setSelected(newSelected);
    const newSyma = getSyma(newSelected, items);
    const changedValue = { syma: newSyma };

    form.setFieldsValue(changedValue);
    const updatedItem = calculateNewItem(changedValue, form.getFieldsValue());
    setItem(updatedItem);
  }

  const onSelectAll = () => {
    const newSelected = items.map(i => i.id);
    setSelected(newSelected);
    const newSyma = getSyma(newSelected, items);
    setSelected(newSelected);

    const changedValue = { syma: newSyma };
    form.setFieldsValue(changedValue); 
    const updatedItem = calculateNewItem(changedValue, form.getFieldsValue());
    setItem(updatedItem);
  }

  const onUnselectAll = () => {
    const newSelected = [];
    const newSyma = 0;
    setSelected(newSelected);

    const changedValue = { syma: newSyma };
    form.setFieldsValue(changedValue); 
    const updatedItem = calculateNewItem(changedValue, form.getFieldsValue());
    setItem(updatedItem);
  }

  const selectedPaymentVid = vidPayments.find(i => i.id === item?.paymentVidId);
  const isCashPayment = selectedPaymentVid?.fiscal === 1;
  const depositPaymentVid = vidPayments.find(i => i.fiscal === 21);
  const depositPaymentOptions = vidPayments
    .filter(option => option.fiscal !== 21 && option.fiscal !== 22 && option.fiscal !== 23)
    .map(i => ({ value: i.id, label: i.name }));

  const renderDepositForm = () => (
    <div style={{
      marginTop: 8,
      paddingTop: 8,
      paddingRight: 8,
      backgroundColor: "#eff2ee",
      border: "1px solid #dddddd",
      borderRadius: "10px",
      ...(isMobile ? { width: "100%", flex: "0 0 100%", maxWidth: "100%", boxSizing: "border-box" } : {}),
    }}>
      <div style={{ marginLeft: 16, marginBottom: 8, fontWeight: 800 }}>Пополнение депозита</div>
      <Form.Item label="Сумма" style={{ marginBottom: 8 }}>
        <InputNumber value={depositAction?.syma} onChange={v => setDepositAction({ ...depositAction, syma: v })} style={isMobile ? { width: "100%" } : { width: 147 }} precision={2} stringMode={false} placeholder="0.00" />
      </Form.Item>
      <Form.Item wrapperCol={ !isMobile ? { span: 12 } : {}} label="Касса" style={{ marginBottom: 8 }}>
        <Select options={depositPaymentOptions} value={depositAction?.paymentVidId} onChange={v => setDepositAction({ ...depositAction, paymentVidId: v })} style={{ width: "100%" }} />
      </Form.Item>
      <Form.Item label={isMobile ? "Коммент." : "Комментарий"} style={{ marginBottom: 8 }}>
        <Input value={depositAction?.comment} onChange={e => setDepositAction({ ...depositAction, comment: e.target.value })} />
      </Form.Item>
      { isMobile ?
      <div style={{ display: "flex", flexDirection: "row", gap: 8, width: "100%", marginBottom: 4 }}>
        <Button style={{ flex: 1, marginLeft: 8 }} onClick={onDepositSubmit} loading={loading}> Пополнить </Button>
        <Button style={{ flex: 1 }} onClick={() => setDepositAction(null)}> Отмена </Button>
      </div> :
      <Form.Item label=" ">
        <Space>
          <Button style={{ width: "150px" }} onClick={onDepositSubmit} loading={loading}>Пополнить</Button>
          <Button style={{ width: "150px" }} onClick={() => setDepositAction(null)}>Отмена</Button>
        </Space>
      </Form.Item>
      }
    </div>
  );

  return <div className="sport-modal">
    <div className="sport-modal-overlay" style={{ zIndex: 10 }} onMouseDown={e => e.target === e.currentTarget && onClose(false)}>
      <div className="sport-modal-content" onMouseDown={e => e.stopPropagation()}>
        <div className="sport-modal-title">
          <span>Оплата</span>
          <CloseCircleOutlined className="sport-section-title-close" onClick={() => onClose(false)} style={{ zIndex: 11 }}/>
        </div>
        <div className="sport-section">
          
          <div className="main-content">
            {!isMobile ?
              <>
                <Button onClick={onSelectAll}>Выбрать все</Button>
                <Button onClick={onUnselectAll}>Снять выделение</Button>
              </>
            :
              <div className="client-item-line-double-halfed">
                <Button onClick={onSelectAll}>Выбрать все</Button>
                <Button onClick={onUnselectAll}>Снять выделение</Button>
              </div>
            }
            {(clientId || visitId) && depositPaymentVid && <Button type={depositAction ? "primary" : "default"} onClick={openDepositAction}>Пополнить депозит</Button>}
          </div>
          <Table dataSource={items} pagination={false} columns={columns} size="small" loading={loading} rowKey="id"
            onRow={record => ({ onClick: () => onRowClick(record) })} hideSelectAll={true}
            rowSelection={{ type: 'checkbox', selectedRowKeys: selected, renderCell: checked => <div className={checked ? "list-indicator" : ""} /> }}
          />
        </div>
        <div className="sport-section">
          <Form form={form} onValuesChange={onValuesChange} labelCol={{ span: 6 }} layout={isMobile ? "inline" : "horizontal"} wrapperCol={ !isMobile ? { span: 18 } : {}} colon={false} disabled={loading}>
            <Form.Item label="ИТОГО" style={isMobile ? {width: "100%", marginBottom: 4} : {}} wrapperCol={ !isMobile ? { span: 4 } : {}} name="syma">
              <Input style={isMobile ? {width: "100%"} : {}} readOnly/>
            </Form.Item>
            <Form.Item wrapperCol={!isMobile ? {span: 12} : {}} style={isMobile ? {width: "100%"} : {}} label="Вид оплаты" name="paymentVidId">
              <Select style={isMobile ? {width: "100%"} : {}} options={vidPaymentsOptions}/>
            </Form.Item>
            {isCashPayment && <>
              <Form.Item wrapperCol={ !isMobile ? { span: 4 } : {}} style={isMobile ? {width: "100%", marginTop: 4} : {}} label="Внесено" name="givenMoney">
                <Input style={isMobile ? {width: "100%"} : {}}/>
              </Form.Item>
              <Form.Item wrapperCol={ !isMobile ? { span: 4 } : {}} style={isMobile ? {width: "100%", marginTop: 4} : {}} label="Сдача" name="changeMoney">
                <Input style={isMobile ? {width: "100%"} : {}} readOnly/>
              </Form.Item>
              <Form.Item name="changeOnDeposit" valuePropName="checked" style={isMobile ? {width: "100%"} : {}}
                wrapperCol={ !isMobile ? { offset: 6, span: 12 } : {offset: 6}}>
                <Checkbox style={!isMobile ? { fontSize: 14 } : {fontSize: 12}}>Сдача на депозит</Checkbox>
              </Form.Item>
            </>}
            {depositAction && (isMobile
              ? <Form.Item noStyle shouldUpdate>
                  <div style={{ width: "100%", flex: "0 0 100%", maxWidth: "100%" }}>
                    {renderDepositForm()}
                  </div>
                </Form.Item>
              : renderDepositForm()
            )}
             {isMobile ? (<>
              {/* <Popconfirm title="Подтверждение" description="Открыть визит?" onConfirm={onSave}>
                <Button disabled={!id || loading || status !== 2 || abon.productVid !== 2}>Открыть визит</Button>
              </Popconfirm> */}
              <Button style={isMobile ? {width: "49%", marginRight: "2%"} : {}} className="sport-btn" onClick={onSave} disabled={loading || !item?.paymentVidId || !item?.syma}>Оплатить</Button>
              <Button style={isMobile ? {width: "49%"} : {}} className="sport-btn" onClick={() => onClose(false)} disabled={loading}>Отмена</Button>
              </>) : (<Form.Item label=" " style={{marginTop: "8px"}}>
              <Space>
                <Popconfirm title="Подтверждение" description="Оплатить сертификат без указанных данных?" open={popconfirmOpen} onConfirm={executePayment} onCancel={() => setPopconfirmOpen(false)}>
                  <Button className="sport-btn" onClick={onSave} disabled={loading || !item?.paymentVidId || !item?.syma}>Оплатить</Button>
                </Popconfirm>
                {/* <Button className="sport-btn" onClick={onSave} disabled={loading || !item?.paymentVidId || !item?.syma}>Оплатить</Button> */}
                <Button className="sport-btn" onClick={() => onClose(false)} disabled={loading}>Отмена</Button>
              </Space>
            </Form.Item>)}
          </Form>
        </div>
      </div>
    </div>
  </div>
}

export default PaymentAdd;
